import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { exchangeGoogleCode } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Google OAuth returns code as a query parameter
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      navigate('/auth', { replace: true });
      return;
    }

    if (!code) {
      navigate('/auth', { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        await exchangeGoogleCode(code);
        navigate('/dashboard', { replace: true });
      } catch {
        navigate('/auth', { replace: true });
      }
    };
    exchange();
  }, [location, navigate, exchangeGoogleCode]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7FAFB]">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-[#1D4053] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#446E87] font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
